import React from "react";
import {Container} from "react-bootstrap";
import imageList2 from "../animal_crossing/imagelist.json";
import {NavLink} from "react-router-dom";
import ImageGallery from "../components/ImageGallery";

const AnimalCrossing = () => {
    const images = imageList2.map((item) => ({
        full: require("../animal_crossing/" + item),
        name: item,
        thumbnail: require("../animal_crossing_thumbnails/" + item + ".jpg")
    }));

    return (
        <>
            <div className={"designs-container"}>
                <nav>
                    <ul>
                        <li><NavLink to='/'>ARTWORKS</NavLink></li>
                        <li><NavLink style={{color: '#fee4ee'}} to='/designs'>DESIGNS</NavLink></li>
                        <li><NavLink to='/about'>ABOUT</NavLink></li>
                    </ul>
                </nav>
                <Container>
                    <div className={"dropdown-shadow-designs"}>
                        <ImageGallery images={images} label="Design" />
                    </div>
                </Container>
            </div>
        </>
    );
};

export default AnimalCrossing;
